import * as React from "react";
import Config from "../../Config";

export default class ContactMap extends React.Component<{}> {

    public render(): React.ReactNode {
        return (

            <div className={"gmap"}>
                <iframe
                    title={'club-map'}
                    src={Config.CONTACT_MAP_SRC}
                    allowFullScreen={false}
                    aria-hidden="false"
                >
                </iframe>
            </div>
        )
    }
}